import { Typography } from 'seagull';
import styles from "./PriceDisplay.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PriceDisplay(props) {
  const {
    priceAfterDiscount,
    priceBeforeDiscount,
    postfixPrice,
    isInButton,
    error,
    'data-testid': testid = ''
  } = props;
  const skin = defaultSkin => error ? 'error' : defaultSkin;
  const style = isInButton ? {
    color: 'unset'
  } : undefined;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.price,
    "data-testid": testid + 'price',
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.priceAndUnit,
      "data-testid": testid + 'price-after-discount',
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        skin: skin(),
        style: style,
        children: priceAfterDiscount
      }), postfixPrice && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: skin(),
        style: style,
        children: postfixPrice
      })]
    }), priceBeforeDiscount && /*#__PURE__*/_jsx("div", {
      "data-testid": testid + 'price-before-discount',
      children: /*#__PURE__*/_jsx(Typography, {
        skin: skin('secondary'),
        textDecoration: "line-through",
        style: style,
        children: priceBeforeDiscount
      })
    })]
  });
}